import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class BonusCodeRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery(fields) {
    return gql`
            query getBonusCodes($filter: BonusCodeFilterInput, $sort: Sorting, $start: Int, $end: Int) {
                getBonusCodes(filter: $filter, sort: $sort, end: $end, start: $start)
                {
                    items {
                        bonus_id
                        bonus_name @include(if: ${this.hasField(fields, "bonus_name")})
                        platform @include(if: ${this.hasField(fields, "platform")})
                        bonus_status @include(if: ${this.hasField(fields, "bonus_status")})
                        threshold @include(if: ${this.hasField(fields, "threshold")})
                        total_paid_out_amount ${this.hasQueryItem(fields, "total_paid_out_amount")}
                        credit_type @include(if: ${this.hasField(fields, "credit_type")})
                        bonus_to_credit @include(if: ${this.hasField(fields, "bonus_to_credit")})
                        release_metric @include(if: ${this.hasField(fields, "release_metric")})
                        release_mechanism @include(if: ${this.hasField(fields, "release_mechanism")})
                        meta @include(if: ${this.hasAnyField(fields, this.getBonusMetaQueryItems())}) {
                            bonus_value_param @include(if: ${this.hasField(fields, "meta.bonus_value_param")})
                            expire_period @include(if: ${this.hasField(fields, "meta.expire_period")})
                            max_bonus_get @include(if: ${this.hasField(fields, "meta.max_bonus_get")})
                            min_deposit @include(if: ${this.hasField(fields, "meta.min_deposit")})
                            overall_max_bonus_get @include(if: ${this.hasField(fields, "meta.overall_max_bonus_get")})
                            rake_amount @include(if: ${this.hasField(fields, "meta.rake_amount")})
                            rake_qualify @include(if: ${this.hasField(fields, "meta.rake_qualify")})
                            metric_amount @include(if: ${this.hasField(fields, "meta.metric_amount")})
                            metric_qualify @include(if: ${this.hasField(fields, "meta.metric_qualify")})
                            show_max_bonus_in_total @include(if: ${this.hasField(fields, "meta.show_max_bonus_in_total")})
                            ticket_serial @include(if: ${this.hasField(fields, "meta.ticket_serial")})
                            time_range_by_date @include(if: ${this.hasField(fields, "meta.time_range_by_date")})
                            total_max_bonus_get @include(if: ${this.hasField(fields, "meta.total_max_bonus_get")})
                            unrealized_expire_period @include(if: ${this.hasField(fields, "meta.unrealized_expire_period")})
                            casino_excluded @include(if: ${this.hasField(fields, "meta.casino_excluded")}) {
                                aggregators
                                game_codes
                                source_types
                                supplier_codes
                            }
                            casino_included @include(if: ${this.hasField(fields, "meta.casino_included")}) {
                                aggregators
                                game_codes
                                source_types
                                supplier_codes
                            }
                        }
                        description @include(if: ${this.hasField(fields, "description")})
                        marketing_codes @include(if: ${this.hasField(fields, "marketing_codes")})
                        create_time @include(if: ${this.hasField(fields, "create_time.seconds")}) {
                            seconds
                        }
                        last_update @include(if: ${this.hasField(fields, "last_update")}) {
                            seconds
                        }
                        start_time @include(if: ${this.hasField(fields, "start_time")}) {
                            seconds
                        }
                        end_time @include(if: ${this.hasField(fields, "end_time")}) {
                            seconds
                        }
                        created_by @include(if: ${this.hasField(fields, "created_by")})
                    }
                    total_count
                }
            }
        `;
  }
  buildFilter(filter) {
    return {
      filter: {
        text: this.getGQLTextFilter(
          Object.keys(this.filterFieldsMapper).map(
            (key) => this.toGQLTextFilter(this.filterFieldsMapper[key], filter[key])
          )
        ),
        bonus_status: this.toGQLMultiselectFilter(filter, "bonusStatus"),
        create_time: this.toGQLDateRange(filter["create_time.from"], filter["create_time.to"]),
        credit_type: this.toGQLMultiselectFilter(filter, "creditType")
      }
    };
  }
  filterFieldsMapper = {
    bonusId: [nameOf("bonus_id")],
    bonusName: [nameOf("bonus_name")],
    idName: [nameOf("bonus_id"), nameOf("bonus_name")],
    createdBy: [nameOf("created_by")]
  };
  getBonusMetaQueryItems() {
    return [
      "meta.bonus_value_param",
      "meta.expire_period",
      "meta.max_bonus_get",
      "meta.min_deposit",
      "meta.overall_max_bonus_get",
      "meta.rake_amount",
      "meta.rake_qualify",
      "meta.show_max_bonus_in_total",
      "meta.ticket_serial",
      "meta.time_range_by_date",
      "meta.total_max_bonus_get",
      "meta.unrealized_expire_period"
    ];
  }
}
export {
  BonusCodeRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
